import $ from "jquery";

export default class Wiz {
    public namespace: any;
    public baseuri: any;

    constructor(baseuri: any) {
        this.baseuri = baseuri;
    }

    public app(namespace: any) {
        let instance = new Wiz(this.baseuri);
        instance.namespace = namespace;
        return instance;
    }

    private cookie(name: string) {
        let ca: Array<string> = document.cookie.split(';');
        let cookieName = `${name}=`;
        for (let item of ca) {
            let value = item.replace(/^\s+/g, '');
            if (value.indexOf(cookieName) == 0) {
                return value.substring(cookieName.length, value.length);
            }
        }
        return '';
    }

    public dev() {
        return this.cookie("season-wiz-devmode") == 'true';
    }

    public project() {
        let project = this.cookie("season-wiz-project");
        if (project) return project;
        return "main";
    }

    public url(function_name: string) {
        if (function_name[0] == "/") function_name = function_name.substring(1);
        return this.baseuri + "/api/" + this.namespace + "/" + function_name;
    }

    public call(function_name: string, data = {}, options: any = {}) {
        let ajax: any = {
            url: this.url(function_name),
            type: "POST",
            data: data,
            ...options
        };
        const csrf = this.cookie("KIERA_CSRF");
        if (csrf) {
            ajax.headers = {
                ...(options.headers || {}),
                "X-KiERA-CSRF": csrf
            };
        }

        return new Promise((resolve) => {
            $.ajax(ajax).always(function (res) {
                resolve(res);
            });
        });
    }
}